import { motion } from 'framer-motion';
import '../../styles/contact.css';

/**
 * HireMeButton — the floating action button visible across all sections.
 * Click opens the Contact modal.
 */
export function HireMeButton({ onClick }) {
  return (
    <motion.button
      className="hire-me-fab"
      onClick={onClick}
      aria-label="Open Hire Me contact form"
      id="hire-me-fab"
      initial={{ opacity: 0, scale: 0.7, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, type: 'spring', stiffness: 260, damping: 22 }}
      whileTap={{ scale: 0.96 }}
    >
      Hire Me
    </motion.button>
  );
}
